'use strict';

var DemandPostingBreakdownModalController = function DemandPostingBreakdownModalController($rootScope, $scope, $filter, chartsDataProvider) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.SOURCE_MODE = 'source';
  $scope.TARGET_MODE = 'target';
  $scope.initModal = function (operationData) {
    var value = operationData.adjustmentData && operationData.adjustmentData.value;
    $scope.operationData = operationData;
    $scope.sourceClassGroup = operationData.source;
    $scope.targetClassGroup = operationData.target;
    $scope.adjAmount = value === 0 ? 'n/a' : rmNumberFormat(operationData.adjustmentData.value * 100, 'PERCENTAGE');
    $scope.adjMode = value === 0 ? 'n/a' : operationData.adjustmentData.mode;
    chartsDataProvider.getData(operationData, $scope.gridParams, $scope.dimension, true).then(function (chartData) {
      $scope.sourceData = chartData.sourceData;
      $scope.targetData = chartData.targetData;
    });
  };
  $scope.showInfoIcon = function () {
    return $scope.adjAmount && $scope.adjAmount !== 'n/a';
  };
};
DemandPostingBreakdownModalController.$inject = ['$rootScope', '$scope', '$filter', 'DemandPostingBreakdownModalDataProviderService'];
module.exports = DemandPostingBreakdownModalController;